import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { KeyRound } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { authApi } from '@/api/endpoints';
import { toast } from '@/store/toast';
import { Loader } from '@/components/common/Loader';

export default function ResetPasswordPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get('token') ?? '';
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [loading, setLoading] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (pw.length < 8) { toast.error('Mínimo 8 caracteres'); return; }
    if (pw !== pw2) { toast.error('Senhas não conferem'); return; }
    setLoading(true);
    try {
      await authApi.confirmReset(token, pw);
      toast.success(t('auth.reset.success'));
      nav('/login', { replace: true });
    } catch (err: any) {
      const reason = err?.response?.data?.reason ?? 'invalid_or_expired_token';
      toast.error(t(`auth.reset.errors.${reason}`, t('auth.reset.errors.invalid_or_expired_token')));
    } finally { setLoading(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center pb-4">
          <div className="mx-auto mb-3 h-14 w-14 rounded-xl bg-primary flex items-center justify-center">
            <KeyRound className="h-7 w-7 text-primary-foreground" />
          </div>
          <CardTitle>{t('auth.reset.title')}</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-2">
              <Label>{t('auth.reset.newPassword')}</Label>
              <Input type="password" required autoFocus value={pw} onChange={e => setPw(e.target.value)} disabled={loading} />
            </div>
            <div className="space-y-2">
              <Label>{t('auth.reset.confirmPassword')}</Label>
              <Input type="password" required value={pw2} onChange={e => setPw2(e.target.value)} disabled={loading} />
            </div>
            <Button type="submit" className="w-full" disabled={loading || !token}>
              {loading ? <Loader /> : t('auth.reset.submit')}
            </Button>
            <Link to="/login" className="block text-center text-sm text-muted-foreground hover:text-foreground">{t('common.back')}</Link>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
